import QuestionsFullAdmin from './views/QuestionsFullAdmin';
export default QuestionsFullAdmin;
